export default function PromisedTimeout(timeout: number) {
    return new Promise(resolve => {
        setTimeout(() => resolve(void 0), timeout);
    });
}

export async function withTimeout<T>(promise: Promise<T>, timeout: number): Promise<T> {
    const deadline = Date.now() + timeout;
    let timer: ReturnType<typeof setTimeout>;
    const timeoutError = () => new Error('Request timed out. Please retry.');
    try {
        const value = await Promise.race([
            promise,
            new Promise<never>((_, reject) => {
                timer = setTimeout(() => reject(timeoutError()), timeout);
            }),
        ]);
        // Background tabs can delay timers. A late response must still be discarded.
        if (Date.now() >= deadline) throw timeoutError();
        return value;
    } finally {
        clearTimeout(timer);
    }
}
